export const EMPLOYEE_TRACKED_CHANGES: Record<string, string[]> = {
  name: ['first_name', 'last_name', 'birth_name'],
  id: ['identifier', 'identifier_type', 'social_security_number'],
  address: ['address_line_1', 'address_line_2', 'city', 'country', 'postal_code', 'state'],
  phone_number: ['phone_number'],
  bank: ['bank_number', 'swift_bic'],
  irpf: ['irpf_cents', 'irpf'],
  nationality: ['nationality'],
  gender: ['gender'],
  termination: ['terminated_on', 'termination_reason_type'],
  residence: ['is_resident'],
  workplace: ['location_name'],
  legal_entity: ['legal_entity_id'],
  tax_id: ['tax_id'],
  email: ['email', 'personal_email'],
  team: ['teams'],
}

export const MESSAGE_SENDER = {
  bookkeeper: 'bookkeeper',
  admin: 'admin',
}
